var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"basic-thumbnail",class:_vm.thumbnailClass},[(_vm.fcIcon)?_c('div',[_c('font-awesome-icon',{staticClass:"basic-thumbnail__icon",style:(_vm.fcIcon.styles),attrs:{"icon":_vm.fcIcon.iconName}})],1):_c('FCImage',{attrs:{"nuxt-image-props":{
      src: _vm.thumbnailImage.filename,
      alt: _vm.thumbnailImage.alt,
      sizes: 'sm:750px',
      width: 750,
      height: 894,
    },"fc-provider":"storyblok"}}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"fc-heading-4 fc-text-black fc-uppercase fc-padding-top-8 fc-text-center"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }